module.exports = __webpack_public_path__ + "img/dash-user.9f93d3e9.svg";